import React from 'react'
import {Provider} from 'react-redux'
import {PersistGate} from 'redux-persist/integration/react'
import styled from 'styled-components'
import {RouteStack} from './routes'
import {ThemeProvider} from './themes'
import {WindowProvider} from './windows'
import {SnackbarProvider} from './common/components/snackbars'
import {REDUX_STORE, REDUX_PERSISTOR} from './lib/redux'

import(/* webpackChunkName: 'RegisterSW' */ './register-sw')

const StyledRoot = styled.div`
  ${({theme}) => ({backgroundColor: theme.white_1})}
  display: flex;
  flex-direction: column;
  height: 100%;
  width: 100vw;
`

export default function App() {
  return (
    <WindowProvider>
      <Provider store={REDUX_STORE}>
        <PersistGate persistor={REDUX_PERSISTOR}>
          <ThemeProvider>
            <SnackbarProvider>
              <StyledRoot>
                <RouteStack />
              </StyledRoot>
            </SnackbarProvider>
          </ThemeProvider>
        </PersistGate>
      </Provider>
    </WindowProvider>
  )
}
